import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      fill="#111"
      stroke="#111"
      strokeWidth={0.3}
      d="M3.67 21.192V2.804a.755.755 0 0 0-.247-.57A.819.819 0 0 0 2.84 2a.836.836 0 0 0-.589.235.749.749 0 0 0-.252.569v18.388a.75.75 0 0 0 .252.571.836.836 0 0 0 .589.235.819.819 0 0 0 .582-.235.757.757 0 0 0 .248-.57ZM19.849 12.832H7.49c-.697 0-1.23.183-1.599.549-.369.366-.554.887-.554 1.566v2.86c0 .683.185 1.206.554 1.568.37.363.902.545 1.6.545h12.358c.69 0 1.222-.182 1.594-.545.372-.363.558-.885.558-1.568v-2.86c0-.678-.186-1.2-.558-1.566-.372-.366-.903-.549-1.594-.549Zm-.147 1.688c.2 0 .35.054.455.162.104.108.156.264.156.468v2.46c0 .206-.052.362-.156.47-.104.107-.256.16-.455.16H7.638c-.2 0-.352-.053-.456-.16-.104-.108-.156-.264-.156-.47v-2.46c0-.204.052-.36.156-.468.104-.108.256-.162.456-.162h12.064ZM14.058 4.077H7.489c-.69 0-1.222.183-1.594.549-.372.366-.558.888-.558 1.566v2.86c0 .677.186 1.198.558 1.564.372.366.903.549 1.594.549h6.569c.69 0 1.222-.183 1.595-.549.372-.366.558-.887.558-1.564v-2.86c0-.678-.186-1.2-.558-1.566-.373-.366-.904-.549-1.595-.549Zm-.146 1.68c.198 0 .35.054.454.161.104.108.157.264.157.469v2.46c0 .205-.053.362-.157.469-.104.107-.255.16-.454.16H7.638c-.2 0-.353-.053-.457-.16-.104-.107-.156-.264-.156-.47v-2.46c0-.204.052-.36.156-.468.104-.107.256-.161.457-.161h6.274Z"
    />
  </svg>
)
export default SvgComponent
